'use strict';
import {combineReducers} from 'redux';
import {model, userPrefs} from '../../app/model/reducers';
import {appNavigation} from '../../app/navigation/reducers';
import {assets} from '../../assets/reducers';
import {auth} from '../../auth/reducers';
import {chat} from '../../comments/reducers';
import {forms} from '../../forms/reducers';
import {milestones} from '../../milestones/reducers';
import {org} from '../../organizations/reducers';
import {personnel} from '../../personnel/reducers';
import {priorities} from '../../priorities/reducers';
import {projects} from '../../projects/reducers';
import {requirements} from '../../requirements/reducers';
import {settings} from '../../settings/reducers';
import {system} from '../../system/reducers';
import {tasks} from '../../tasks/reducers';
import {timers} from '../../timers/reducers';
import {todoMessages} from '../../todo-messages/reducers';
import {userProfile} from '../../user-profile/reducers';
import {stateVersionProp, versionReducer} from '../redux-storage';
import {ROUTER_NAME} from './state';
import {routerReducer} from './routerReducer';
import {buildLogger} from '../logger';


const logger = buildLogger('globals/rootReducer');

export const baseRootReducer = combineReducers({
  [ROUTER_NAME]: routerReducer,
  [stateVersionProp]: versionReducer,
  assets,
  auth,
  model,
  userPrefs,
  appNavigation,
  chat,
  forms,
  milestones,
  org,
  personnel,
  priorities,
  projects,
  requirements,
  settings,
  system,
  tasks,
  timers,
  todoMessages,
  userProfile,
});

/**
 * TODO(redux): decide on error handling strategy.
 * These errors should only occur in development due to lack of test coverage.
 *
 * A.) Dispatch an action or just async call something to display to the user that a critical error has occurred, please restart the app.
 *     > This probably an acceptable strategy.
 *
 * B.) Return the original state, disregarding the action.
 *     > Epics have likely still processed the action, so this would likely be result in strange bugs.
 *
 * C.) Come up with something else.
 *
 */
export function rootReducer(state, action) {
  try {
    return baseRootReducer(state, action);
  } catch (err) {
    logger.error({err}, 'Error occurred in reducer');
    throw err;
  }
}



// WEBPACK FOOTER //
// ./src/js/config/reducers/index.js